import type { SocialSignupType } from 'src/features/signup/components/signup-form/signup-form.types';

interface UseSocialLoginUrlOptions {
  redirectTo?: string | null;
  social: SocialSignupType;
}

export const useSocialLoginUrl = ({ redirectTo, social }: UseSocialLoginUrlOptions) => {
  const params = new URLSearchParams();

  if (redirectTo) params.set('redirectTo', redirectTo);

  const queryString = params.toString();
  return queryString ? `/login/${social}?${queryString}` : `/login/${social}`;
};
